import * as Icon from "@ant-design/icons";
import { Modal, Flex, Form, Row, Col } from "antd";
import { ColumnsType } from "antd/es/table";
import { useEffect } from "react";
import { CategoriaEmpresaModel } from "../../models/categoriaEmpresa/categoriaEmpresaModel";
import { useAppSelector, useAppDispatch } from "../../util/hooks";
import CadastroCategoriaEmpresaModal from "./modals/cadastrar";
import { setEntityCategoriaEmpresa, setModalCadastrarCategoriaEmpresa, setModalDeletarCategoriaEmpresa } from "../../redux/slices/categoriaEmpresa/categoriaEmpresaSlice";
import { setTitle } from "../../redux/slices/configuracoes/configuracoesSlice";
import { buscarCategoriaEmpresa, deletarCategoriaEmpresa } from "../../services/categoriaEmpresaService";
import { verificarPermissaoEmpresa } from "../../util/functions/verificarPermissaoEmpresa";
import TableComponent from "../../components/table/tableComponent";
import AcoesComponent from "../../components/table/acoesComponent";
import { ItemMenuAcoes } from "../../models/sistema/itemMenuAcoes";
import MensagemModal from "../../components/modal/mensagem";
import { ButtonComponent } from "../../components/button/cadastrar";

const CategoriaEmpresa = () => {
  //estados globais
  const categoriaEmpresaState = useAppSelector((state) => state.categoriaEmpresa);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais

  const editar = Object.values(categoriaEmpresaState.entity).length !== 0;

  useEffect(() => {
    dispatch(setTitle("CATEGORIA DE EMPRESA"));
    dispatch(buscarCategoriaEmpresa());
  }, []);

  const goCadastro = () => {
    dispatch(setEntityCategoriaEmpresa({}));
    dispatch(setModalCadastrarCategoriaEmpresa(true));
  };

  const closeModalCadastro = () => {
    dispatch(setModalCadastrarCategoriaEmpresa(false));
  };

  const goEditar = (value: CategoriaEmpresaModel) => {
    dispatch(setEntityCategoriaEmpresa(value));
    dispatch(setModalCadastrarCategoriaEmpresa(true));
  };

  const goDeletar = (value: CategoriaEmpresaModel) => {
    dispatch(setEntityCategoriaEmpresa(value));
    dispatch(setModalDeletarCategoriaEmpresa(true));
  };

  const closeModalDeletar = () => {
    dispatch(setModalDeletarCategoriaEmpresa(false));
  };

  const items: ItemMenuAcoes[] = [
    {
      label: "Editar",
      key: "1",
      icon: <Icon.EditOutlined />,
      function: (item: any) => goEditar(item),
    },
    {
      label: "Remover",
      key: "2",
      icon: <Icon.DeleteOutlined />,
      function: (item: any) => goDeletar(item),
    },
  ];

  const columns: ColumnsType<CategoriaEmpresaModel> = [
    {
      title: "ABREVIAÇÃO",
      dataIndex: "abreviacao",
      sorter: (a, b) => a.abreviacao.localeCompare(b.abreviacao),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "DENOMINAÇÃO",
      dataIndex: "denominacao",
      sorter: (a, b) => a.denominacao.localeCompare(b.denominacao),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "EXIGE SORTEIO",
      dataIndex: "exigeSorteioContaFinanceira",
      align: "center",
      render: (_, record) => <>{record.exigeSorteioContaFinanceira ? "SIM" : "NÃO"}</>,
    },
    {
      title: "AÇÕES",
      dataIndex: "acoes",
      align: "center",
      width: 75,
      render: (_, record) => <AcoesComponent record={record} items={items} />,
    },
  ];

  return (
    <Flex vertical>
      <Form layout="vertical">
        <Row gutter={12}>
          <Col span={24}>
            <Flex justify="end">
              <ButtonComponent onClick={goCadastro} />
            </Flex>
          </Col>
        </Row>
      </Form>
      <TableComponent data={categoriaEmpresaState.list} columns={columns} loading={categoriaEmpresaState.loading} />
      <Modal
        title={editar ? "EDITAR CATEGORIA EMPRESA" : "NOVA CATEROGIA EMPRESA"}
        centered
        width={950}
        open={categoriaEmpresaState.modalCadastrar}
        closable={false}
        onCancel={closeModalCadastro}
        footer={null}
        destroyOnHidden
      >
        <CadastroCategoriaEmpresaModal />
      </Modal>
      <Modal title={"REMOVER CATEGORIA EMPRESA"} centered width={350} open={categoriaEmpresaState.modalDeletar} closable={false} onCancel={closeModalDeletar} footer={null} destroyOnHidden>
        <MensagemModal text="Deseja remover a categoria empresa?" action={deletarCategoriaEmpresa({ value: categoriaEmpresaState.entity.id })} close={setModalDeletarCategoriaEmpresa(false)} />
      </Modal>
    </Flex>
  );
};

export default CategoriaEmpresa;
